import React from 'react';
import { FulfillmentOrderItemsExpandListTemplate } from 'themes/modules/order/pages';
import { FulfillmentOrderItemsExpandListViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new FulfillmentOrderItemsExpandListViewStore(rootStore, componentProps),
	'fulfillmentOrderItemsExpandListViewStore'
)
class FulfillmentOrderItemsExpandList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<FulfillmentOrderItemsExpandListTemplate
				{...this.props}
				fulfillmentOrderItemsExpandListViewStore={this.props.fulfillmentOrderItemsExpandListViewStore}
			/>
		);
	}
}

export default FulfillmentOrderItemsExpandList;



// WEBPACK FOOTER //
// ./src/modules/order/pages/FulfillmentOrderItemsExpandList.jsx